import { FormGroup } from '@angular/forms';
import { InputTextComponent } from '../input-text/input-text.component';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponent implements OnInit, AfterViewInit {

	@Input() form:FormGroup;
	@Input() name:string;
	@Input() label:string;
	@Input() width:string = '224';
	@Input() data:{label:string, value:string}[];
	
	classes:string[];
	
  constructor() { }

  ngOnInit() {
		
		this.classes = [];
		// if (this.form.controls[name].value == "") this.classes.push('placeholder');
		this.classes.push('input-'+this.width);
	}
	
	ngAfterViewInit()
	{
		
	}
	
	erase()
	{
		this.form.controls[this.name].setValue('');

	}

}
